  const cardStyle = {
    background: "#fff",
    borderRadius: "1.5rem",
    padding: "1.25rem",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    display: "flex",
    flexDirection: "column",
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "1rem",
    letterSpacing: "0.05em",
    color: "#6B7280",
    margin: "0 0 0.5rem 0",
  };

  const storeLabelStyle = {
    fontSize: "0.75rem",
    width: "50px",
    flexShrink: 0,
    fontWeight: "700",
    color: "#333333",
  };

export function ConcentrationCard({ ctx }) {

  const { stores } = ctx || {};

  const maxPercent = Math.max(
    ...stores.map(s => Math.max(s.volumePercent, s.costPercent))
  );

  return (
    <div style={cardStyle}>
      <p style={titleStyle}>CONCENTRAÇÃO DE 3% DA VENDA</p>
      <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.75rem" }}>
        <LegendDot color="#F97316" label="VOLUME DE ESTOQUE" />
        <LegendDot color="#374151" label="CUSTO DE ESTOQUE" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", flex: 1 }}>
        {stores.map((store) => (
          <div key={store.name} style={{ marginBottom: "0.9rem" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
              <span style={storeLabelStyle}>{store.name}</span>
              <span style={{
                fontSize: "0.65rem", fontWeight: "700",
                fontFamily: "'Public Sans', system-ui, sans-serif",
                display: "flex", gap: "0.5rem"
              }}>
                <span style={{ color: "#F97316" }}>{store.volumePercent}%</span>
                <span style={{ color: "#374151" }}>{store.costPercent}%</span>
              </span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <div style={{ height: "8px", background: "#E5E7EB", borderRadius: "4px", overflow: "hidden" }}>
                <div style={{
                  height: "100%",
                  width: `${(store.volumePercent / maxPercent) * 100}%`,
                  background: "linear-gradient(to right, #ED701D, #FDBA74)",
                  borderRadius: "4px"
                }} />
              </div>
              <div style={{ height: "8px", background: "#E5E7EB", borderRadius: "4px", overflow: "hidden" }}>
                <div style={{
                  height: "100%",
                  width: `${(store.costPercent / maxPercent) * 100}%`,
                  background: "#374151",
                  borderRadius: "4px"
                }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function LegendDot({ color, label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
      <div style={{ width: 10, height: 10, borderRadius: "50%", background: color }} />
      <span style={{
        fontSize: "0.6rem", color: "#4B5563", fontWeight: "700",
        fontFamily: "'Public Sans', system-ui, sans-serif"
      }}>
        {label}
      </span>
    </div>
  );
}